import TrackerDataTableItemCollaborators
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemCollaborators/TrackerDataTableItemCollaborators'

export default {
  name: 'TrackerDataTableItemCollaboratorsMobile',
  mixins: [TrackerDataTableItemCollaborators],
  inject: ['provideConfiguration'],
  computed: {
    viewLayout () {
      return this.provideConfiguration.mobile?.viewLayout?.filter((layout) => layout.id === 'TrackerDataTableItemCollaboratorsMobile')[0]
    }
  }
}
